import React, { Component } from "react";
import { observer } from "mobx-react";
import look from "../../static/images/look.png";
import looked from "../../static/images/looked.png";
import unlook from "../../static/images/unlook.png";
import { setRead } from "../../static/js/http";
import "./index.css";
import home from "../../store/index";
import { Toast } from "antd-mobile";
import {deXMLFilter} from '../../static/js/utils'
@observer
class QuestionsItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      flag:
        props.rowData &&
        props.rowData.storeQuestionEntity.answerStatus === "read",
      lookImg: props.rowData && props.rowData.storeQuestionEntity.answerStatus,
    };
  }

  show() {
    if (this.props.rowData.storeQuestionEntity.answerStatus === "answered") {
      if (this.state.lookImg === "read") {
        if (home.MyShowId === this.props.rowID) {
          home.MyShowId = "no";
        } else {
          home.MyShowId = this.props.rowID;
          this.props.changeShowId(this.props.rowData);
        }
      } else {
        setRead(this.props.rowData.storeQuestionEntity.id)
          .then((res) => {
            if (res.msg === "success") {
              this.setState({
                lookImg: "read",
              });
              // home.unReadQquestion();
              home.getOnceMyEmail();
            }
          })
          .catch((err) => {});
        this.props.changeShowId(this.props.rowData);
      }
    }
    if (this.props.rowData.storeQuestionEntity.answerStatus === "read") {
      if (home.MyShowId === this.props.rowID) {
        home.MyShowId = "";
      } else {
        home.MyShowId = this.props.rowID;
        this.props.changeShowId(this.props.rowData);
      }
    }
    if (this.props.rowData.storeQuestionEntity.answerStatus === "notAnswered") {
      if (this.props.rowData.storeQuestionEntity.answer) {
        if (home.MyShowId === this.props.rowID) {
          home.MyShowId = "";
        } else {
          home.MyShowId = this.props.rowID;
          this.props.changeShowId(this.props.rowData);
        }
      } else {
        Toast.info("解忧人暂未回复，请耐心等待~", 1);
      }
    }
  }
  changbg() {
    if (this.state.lookImg === "notAnswered") {
      return "mailbox_list mailbox_list_unbg";
    } else if (this.state.lookImg === "answered") {
      return "mailbox_list mailbox_list_bg";
    }
    if (this.state.lookImg === "read") {
      return "mailbox_list mailbox_list_bged";
    } else {
      return "mailbox_list";
    }
  }
  changelook() {
    if (this.state.lookImg === "notAnswered") {
      return unlook;
    } else if (this.state.lookImg === "answered") {
      return look;
    }
    if (this.state.lookImg === "read") {
      return looked;
    } else {
      return unlook;
    }
  }
  changeShowId() {
    this.props.changeShowId();
  }
  render() {
    return (
      <div
        className={this.changbg()}
        onClick={() => {
          this.show();
        }}
      >
        <i>
          <img src={this.changelook()} alt="" />
        </i>
        <div className="mailbox_list_q">
          {this.props.rowData &&
            deXMLFilter(this.props.rowData.storeQuestionEntity.question)}
        </div>
      </div>
    );
  }
}
export default QuestionsItem;
